import React, { useState } from 'react';
import Button from 'common/components/Button';
import { useSearchParams } from 'react-router-dom';
import Input from 'common/components/Input';
import Switch from 'common/components/Switch';
import sendFetch from 'common/utils/fetch';
import RoleTypes from 'common/types/RoleTypes';
import { useTheme } from '@mui/material';

export const EditRole = ({ roleList, handleDelete, updateRoleList }:{ roleList: RoleTypes[], handleDelete:(id:string) => void, updateRoleList:()=>void }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get('id');
  const currentRole = roleList.find((item) => item.id === id);
  const [name, setName] = useState(currentRole.name);
  const [nameError, setNameError] = useState(false);
  /*const [ownerCheck, setOwnerCheck] = useState(false);
  const [adminCheck, setAdminCheck] = useState(false);
  const [employeeCheck, setEmployeeCheck] = useState(true);*/
  const [check, setCheck] = useState([currentRole.userRole === 2, currentRole.userRole === 1, currentRole.userRole === 0]);
  const theme = useTheme();
  

  const handleRemovePage = () => {
    searchParams.delete('page');
    setSearchParams(searchParams);
  };

  const updateRole = async () => {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('id', id);
    formData.append('userRole', check[0] ? '2' : check[1] ? '1' : '0');
    const response = await sendFetch('https://api-workspace.astin.net/api/company-role/update-role', {
      method: 'POST',
      data: formData,
    });
    if (response[0] === 200) {
      updateRoleList();
      handleRemovePage();
    }
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (nameError && e.target.value.length > 0) {
      setNameError(false);
    }
    setName(e.target.value);
  };
  const handleCheckChange = (index: number) => {
    const newCheck = [...check];
    // if other checks are false don't allow to change current to false
    if (newCheck[index]) {
      let checkedCount = 0;
      newCheck.forEach((item) => {
        if (item) checkedCount++;
      });
      if (checkedCount === 1) return;
    }
    newCheck[index] = !newCheck[index];
    // reset other checks if current is true now
    if (newCheck[index]) {
      newCheck.forEach((item, i) => {
        if (i !== index) {
          newCheck[i] = false;
        }
      });
    }
    setCheck(newCheck);
  };

  const handleFormSubmit = () => {
    if (name.length < 1) {
      setNameError(true);
    } else {
      setNameError(false);
      updateRole();
    }
  };
  return (
    <div className='role-add-wrapper'>
      <div className='role-add-line'>
        <h4>Назва</h4>
        <Input placeholder='Введіть назву' value={name} onChange={handleNameChange} props={{ className: 'role-add-input' }} error={nameError} />
      </div>
      <div className='role-add-switch-line'>
        <h4>Власник</h4>
        <Switch checked={check[0]} onChange={() => { handleCheckChange(0); }} />
      </div>
      <div className='role-add-switch-line'>
        <h4>Адміністратор</h4>
        <Switch checked={check[1]} onChange={() => { handleCheckChange(1); }} />
      </div>
      <div className='role-add-switch-line'>
        <h4>Співробітник</h4>
        <Switch checked={check[2]} onChange={() => { handleCheckChange(2); }} />
      </div>
      <Button className='add-role-button' label='Зберегти' onClick={handleFormSubmit} />
      <Button label='Видалити' customPalette={theme.palette.error} onClick={()=>{handleDelete(id);}} />
    </div>
  );
};
